var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-5 d-flex flex-column justify-content-center align-items-center"},[_c('em',{staticClass:"fas fa-check-circle color-primary-1",staticStyle:{"font-size":"50px"}}),_c('div',{staticClass:"color-black-1 font-18 mt-4 text-center"},[_vm._v(" "+_vm._s(_vm.$t('YourPasswordHasBeenChanged'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }